import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { emptyObject } from 'ui-components/default-props/empty';
import { FulfillmentPlanFulfillmentType } from '../../../../../../enums/fulfillment-plan-fulfillment-type';
import { useEntitiesFulfillmentPlan } from '../../../../../../hooks/entities/selectors/fulfillment-plans';
import { useEntitiesFulfillment } from '../../../../../../hooks/entities/selectors/fulfillments';
import { useIsServiceLocalDelivery } from '../../../../../../hooks/use-is-service-local-delivery';
import { useSellerLabelProvider } from '../../../../../../hooks/use-seller-label-provider';
import { useSellerFulfillmentProvider } from '../../../../../../hooks/use-seller-fulfillment-provider';
import { ShipmentHelperService } from '../../../../../../services/shipment-helper-service';
import Global from '../../../../../../store/global-selectors';

export const useReadonlyRateCard = ({ fulfillmentPlanId, fulfillmentId }) => {
  const fulfillment = useEntitiesFulfillment(fulfillmentId) || emptyObject;
  const fulfillmentPlan = useEntitiesFulfillmentPlan(fulfillmentPlanId) || emptyObject;
  const serviceReferenceLookup = useSelector(Global.selectReferenceDatagetServiceReferenceLookup);

  const {
    serviceId: fulfillmentPlanServiceId,
    sellerLabelProviderId: fulfillmentPlanSellerLabelProviderId,
    shipDate: fulfillmentPlanShipDate,
    fulfillmentType: fulfillmentPlanType,
  } = fulfillmentPlan;

  const {
    trackingInformation,
    shipDateTime: fulfillmentShipDate,
    labelProviderId: fulfillmentLabelProviderId,
    serviceId: fulfillmentServiceId,
    carrierId,
    sellerFillProviderId,
    createDateTime: fulfillmentCreatedDateTime,
  } = fulfillment;

  const { labelProviderId: fulfillmentPlanLabelProviderId } = useSellerLabelProvider(fulfillmentPlanSellerLabelProviderId) || emptyObject;

  const sellerFulfillmentProvider = useSellerFulfillmentProvider(sellerFillProviderId, true) || emptyObject;
  const fillProviderId = sellerFulfillmentProvider.fulfillmentProviderId;

  const serviceId = fulfillmentServiceId || fulfillmentPlanServiceId;
  const labelProviderId = fulfillmentLabelProviderId || fulfillmentPlanLabelProviderId;
  const shipDate = fulfillmentShipDate || fulfillmentPlanShipDate;

  const isLocalDelivery = useIsServiceLocalDelivery(serviceId);

  const totalCost = ShipmentHelperService.getTotalCost(fulfillment);

  const selectedService = serviceReferenceLookup[serviceId];

  const { trackingNumber, url } = trackingInformation || {};

  const isMarkAsShipped = fulfillmentPlanType === FulfillmentPlanFulfillmentType.Manual;

  const delegationDateTime = fulfillmentPlanType === FulfillmentPlanFulfillmentType.External ? fulfillmentCreatedDateTime : null;

  return useMemo(() => {
    return {
      fulfillmentId,
      trackingNumber,
      trackingUrl: url,
      serviceName: selectedService?.name,
      shipDate,
      labelProviderId,
      fillProviderId,
      serviceId,
      totalCost,
      isLocalDelivery,
      isMarkAsShipped,
      carrierId,
      delegationDateTime,
    };
  }, [
    fulfillmentId,
    fillProviderId,
    labelProviderId,
    selectedService?.name,
    delegationDateTime,
    serviceId,
    shipDate,
    totalCost,
    trackingNumber,
    url,
    isLocalDelivery,
    isMarkAsShipped,
    carrierId,
  ]);
};
